import { render, staticRenderFns } from "./ReportUpgradeCard.vue?vue&type=template&id=015035bb&scoped=true"
import script from "./ReportUpgradeCard.vue?vue&type=script&lang=js"
export * from "./ReportUpgradeCard.vue?vue&type=script&lang=js"
import style0 from "./ReportUpgradeCard.vue?vue&type=style&index=0&id=015035bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015035bb",
  null
  
)

export default component.exports